export const PERMISSION = {
  ALL: 0,
  LIST: 1,
  CREATE: 2,
  EDIT: 3,
  DELETE: 4,
};

export const MODULE = {
  USER: 1,
  COMPANY: 2,
  // DOTP: 3, // Donation over the phone
  SECURITY_GROUP: 4,
  PBI_REPORT: 5,
  PBI_REPORT_VIEWER: 6,
  SUPPORTER: 7,
  EXPORTS_DATA: 8
};